import { render } from "./TemplateDbsMyUsing.vue?vue&type=template&id=112f7d3a&scoped=true"
import script from "./TemplateDbsMyUsing.vue?vue&type=script&lang=js"
export * from "./TemplateDbsMyUsing.vue?vue&type=script&lang=js"

import "./TemplateDbsMyUsing.vue?vue&type=style&index=0&id=112f7d3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-112f7d3a"

export default script